import { IcFileConfig } from '@assets/icons/40x40';
import { For, Text, VStack } from '@chakra-ui/react';
import { SensorOrSubSensorInfoByType } from '@components/cockpit/panels/monitoring/monitoring.types';
import DataSheetCardLink from '@components/common/layout/DataSheetCardLink';
import { getAutomatonNodeName } from '@utils/map/automatonSection.utils';
import { FormattedMessage, useIntl } from 'react-intl';

import { SubSensorTypeEnum } from '@/types/sensor/sensors';

type Props = {
  sensorOrSubSensorInfo: SensorOrSubSensorInfoByType<SubSensorTypeEnum.AUTOMATON_CABINET>;
};

export default function CabinetMaintenanceLink({ sensorOrSubSensorInfo }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  const cabinetsStates = sensorOrSubSensorInfo.status?.cabinetStates;

  return (
    <DataSheetCardLink
      arrowOrientation="bottom"
      icon={IcFileConfig}
      label={formatMessage({ id: 'sensors.tab.maintenance.cabinet.technical' })}
    >
      <VStack
        padding="standardM"
        backgroundColor="neutral.800"
        width="100%"
        maxHeight="250px"
        className="popup-scrollbar"
      >
        <VStack gap={2} alignItems="start">
          <VStack width="100%" gap={1} alignItems="start">
            <For
              each={Object.entries(cabinetsStates ?? {})}
              fallback={
                <Text wordBreak="break-word">
                  <FormattedMessage id="sensors.status.NA" />
                </Text>
              }
            >
              {([key, values]) => {
                return (
                  <VStack key={key} gap={0.5} alignItems="start" paddingRight={2}>
                    <Text textStyle="md" fontWeight="medium" color="neutral.300">
                      <FormattedMessage id={`automatonCabinet.state.${key}`} />
                    </Text>
                    <VStack alignItems="start" gap={0.25} userSelect="text">
                      <For each={values.toSorted((a, b) => a.localeCompare(b))}>
                        {(value) => (
                          <Text key={value} wordBreak="break-all">
                            {getAutomatonNodeName(value)}
                          </Text>
                        )}
                      </For>
                    </VStack>
                  </VStack>
                );
              }}
            </For>
          </VStack>
        </VStack>
      </VStack>
    </DataSheetCardLink>
  );
}
